import React from 'react';
import { useSelector } from 'react-redux';
import { UiIcon } from 'ui-components';
import { useTranslation } from 'react-i18next';
import { StyledFixedHelpingArrows } from './FixedHelpingArrows.styles';

const FixedHelpingArrows = () => {
  const { t } = useTranslation();
  const isLeftOrRightKeyClicked = useSelector(
    (state) => state.storyReducer.isLeftOrRightKeyClicked
  );
  const storyDetailModal = useSelector(
    (state) => state.storyReducer.storyDetailModal
  );

  return (
    storyDetailModal &&
    !isLeftOrRightKeyClicked && (
      <StyledFixedHelpingArrows>
        <div className='fixed-helping-arrows'>
          <span className=''>{t('content:keyboardShortcut')}</span>
          <div className='arrow-wrapper'>
            <UiIcon
              className='arrow-icon'
              icon='ri-arrow-right-s-line'
              color='#454545'
              size={20}
            />
            <span className='arrow-label'>{t('content:prevContent')}</span>
          </div>
          <div className='arrow-wrapper'>
            <UiIcon
              className='arrow-icon'
              icon='ri-arrow-left-s-line'
              color='#454545'
              size={20}
            />
            <span className='arrow-label'>{t('content:nextContent')}</span>
          </div>
        </div>
      </StyledFixedHelpingArrows>
    )
  );
};

export default FixedHelpingArrows;
